/**
 * AiHelpWidget - Main container component for AI Help Chat
 *
 * State machine:
 * - minimized: just the bubble
 * - sessions: session list panel
 * - chat: single chat panel
 */

import React, { useEffect } from 'react';
import { useAiHelpStore } from '../../lib/stores/aiHelpStore';
import { useAuth } from '../../lib/auth';
import { AiHelpBubble } from './AiHelpBubble';
import { AiHelpSessionList } from './AiHelpSessionList';
import { AiHelpPanel } from './AiHelpPanel';

export function AiHelpWidget() {
  const { userProfile } = useAuth();
  const { widgetState, setWidgetState, fetchSessions } = useAiHelpStore();

  // Fetch sessions when user is available
  useEffect(() => {
    if (userProfile?.id) {
      fetchSessions();
    }
  }, [userProfile?.id, fetchSessions]);

  if (!userProfile) return null;

  const handleBubbleClick = () => {
    if (widgetState === 'minimized') {
      setWidgetState('chat');
    } else {
      setWidgetState('minimized');
    }
  };

  const handleClose = () => {
    setWidgetState('minimized');
  };

  const handleBackToSessions = () => {
    setWidgetState('sessions');
  };

  return (
    <>
      {/* Bubble removed — AI button now in DynamicHeader */}

      {/* Session list */}
      {widgetState === 'sessions' && (
        <AiHelpSessionList onClose={handleClose} />
      )}

      {/* Chat panel */}
      {widgetState === 'chat' && (
        <AiHelpPanel
          onClose={handleClose}
          onBack={handleBackToSessions}
        />
      )}
    </>
  );
}
